import { IconManifest } from 'app/agriculture/icons/types';
import { Symbol } from './Symbol';

interface BillboardIconProps {
    icon?: IconManifest;
    iconColor: string;
    x?: number;
    y?: number;
}

export function BillboardIcon({ icon, iconColor, x, y }: BillboardIconProps) {
    if (!icon) return '';

    const symbol = Symbol({ icon });
    const use = `
        <use
            href="#${icon.id}"
            x="${x}"
            y="${y}"
            width="128"
            height="128"
            fill="${iconColor}"
        />
    `;

    return symbol + use;
}
